import { render } from "./BasketballMatchContent.vue?vue&type=template&id=1dcaf7ad&scoped=true"
import script from "./BasketballMatchContent.vue?vue&type=script&lang=js"
export * from "./BasketballMatchContent.vue?vue&type=script&lang=js"

import "./BasketballMatchContent.vue?vue&type=style&index=0&id=1dcaf7ad&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcaf7ad"]])

export default __exports__